import React, {FC} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import ModalTypes from '../../enums/app/modalTypes';
import {selectGlobalModals} from '../../state/selectors/modal';
import DeviceInSblModePopup from './DeviceInSblModePopup/DeviceInSblModePopup';
import FWUAdditionalStepsGuidePopup from './FWUAdditionalStepsGuidePopup/FWUAdditionalStepsGuidePopup';
import FWUErrorPopup from './FWUErrorPopup/FWUErrorPopup';
import FWULedCheckPopup from './FWULedCheckPopup/FWULedCheckPopup';
import HidReconnectPopup from './HidReconnectPopup/HidReconnectPopup';
import PairingGuideErrorPopup from './PairingGuideErrorPopup/PairingGuideErrorPopup';
import ReconnectDeviceGuidePopup from './ReconnectDeviceGuidePopup/ReconnectDeviceGuidePopup';
import UsbRequiredPopup from './UsbRequiredPopup/UsbRequiredPopup';

const MODAL_COMPONENTS = {
    [ModalTypes.PAIRING_GUIDE_ERROR]: PairingGuideErrorPopup,
    [ModalTypes.HID_RECONNECT]: HidReconnectPopup,
    [ModalTypes.DEVICE_IS_IN_SBL]: DeviceInSblModePopup,
    [ModalTypes.RECONNECT_DEVICE_GUIDE]: ReconnectDeviceGuidePopup,
    [ModalTypes.FWU_ADDITIONAL_STEPS_GUIDE]: FWUAdditionalStepsGuidePopup,
    [ModalTypes.FWU_LED_CHECK]: FWULedCheckPopup,
    [ModalTypes.FWU_ERROR]: FWUErrorPopup,
    [ModalTypes.USB_REQUIRED]: UsbRequiredPopup,
};

const ModalsRoot: FC = () => {
    const modals = useSelector(selectGlobalModals);
    const dispatch = useDispatch();

    if (!modals.length) return null;

    return (
        <>
            {modals.map((modal) => {
                const {modalType, modalProps} = modal;
                const SpecificModal = MODAL_COMPONENTS[modalType];

                return SpecificModal ? (
                    <SpecificModal key={modalType} {...modalProps} modalType={modalType} dispatch={dispatch} />
                ) : null;
            })}
        </>
    );
};

export default ModalsRoot;
